import { useState } from "react";
import "./FilterBar.css";
import PartnerSelectModal from "./PartnerSelectModal";
const FilterBar = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  selectedPartner,
  setSelectedPartner,
  partners,
  onCalculate
}) => {

  const [showPartnerModal, setShowPartnerModal] = useState(false);
console.log(partners);
  return (
    <div className="filter-bar">

      <input
        type="date"
        value={startDate}
        onChange={e => setStartDate(e.target.value)}
      />

      <input
        type="date"
        value={endDate}
        onChange={e => setEndDate(e.target.value)}
      />

      {/* ✅ NEW PARTNER BUTTON */}
      <button
        className="filter-btn"
        onClick={() => setShowPartnerModal(true)}
      >
        {selectedPartner?.name || "Select Partner"}
      </button>
{/* 
      <button className="Calculate-btn" onClick={onCalculate}>
        Calculate
      </button> */}

      {/* ✅ PARTNER MODAL */}
      <PartnerSelectModal
        title="Select Partner"
        items={partners.map(p => ({
          label: p.name,
          value: p.id
        }))}
        selected={selectedPartner?.id}
        onSelect={(value) => {
          const selected = partners.find(p => p.id === value);
          setSelectedPartner(selected);
        }}
        show={showPartnerModal}
        onClose={() => setShowPartnerModal(false)}
      />

    </div>
  );
};

export default FilterBar;